import { render, staticRenderFns } from "./AllVideoModules.vue?vue&type=template&id=1bc45fc9"
import script from "./AllVideoModules.vue?vue&type=script&lang=js"
export * from "./AllVideoModules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports